<div class="zn-header-container">
  <div class="zn-header-row">
    <div class="title-container">
      <h5 class="card-title">{{ tableName() | abpLocalization }}</h5>
      <div class="zn-header-subtitle">
        @if (subtitleTemplate(); as subtitleTpl) {
          <ng-container [ngTemplateOutlet]="subtitleTpl"></ng-container>
        } @else {
          <ng-content select="[table-header-subtitle]"></ng-content>
        }
      </div>
    </div>
    <div class="zn-header-col">
      @if (actionsTemplate(); as actionsTpl) {
        <div class="zn-header-custom-actions">
          <ng-container [ngTemplateOutlet]="actionsTpl"></ng-container>
        </div>
      }
      <!-- buttons/layout -->
      <app-layout-list (selectedLayoutChange)="onLayoutChange($event)"></app-layout-list>
      @if(canCreate()) {
        <zn-button
        [label]="localizationResource.LanguageService + '::TableNewRegistry' | abpLocalization"
        type="primary"
        size="normal"
        iconRight="bi bi-plus-lg"
        (clicked)="onCreateRecord()"
        [disabled]="disable()"
      >
      </zn-button>
      }
    </div>
  </div>
  @if (showHeaderRow()) {
    <div class="zn-header-row">
      <div class="zn-header-col zn-header-actions">
        <!-- selected, duplicate, delete, save, cancel -->
        @switch (activeMode()) { @case (headerMode.Selection) { @if (selectedItems() === 1) {
        <p class="selected-items-text">
          {{selectedItems()}} {{localizationResource.LanguageService +
          '::TableSelectedElement' |abpLocalization}}
        </p>
        }@else {
        <p class="selected-items-text">
          {{selectedItems()}} {{localizationResource.LanguageService +
          '::TableSelectedElements' |abpLocalization}}
        </p>
        }
        <hr class="zn-separator-vertical" />
        @if(canDelete()) {
          <zn-button
          [label]="localizationResource.LanguageService + '::Delete' | abpLocalization"
          type="tertiary"
          size="normal"
          iconLeft="bi bi-trash3"
          (clicked)="onDeleteRecord()"
        >
        </zn-button>
        }
        @if(canCreate() && !disableDuplicate()) {
          <zn-button
          [label]="localizationResource.LanguageService + '::TableDuplicate' | abpLocalization"
          type="tertiary"
          size="normal"
          iconLeft="bi bi-copy"
          (clicked)="onDuplicateRecord()"
        >
        </zn-button>
        }
        <zn-button
          [label]="localizationResource.LanguageService + '::TableSummary' | abpLocalization"
          type="tertiary"
          size="normal"
          iconLeft="zn-sigma"
          class="button-info"
          (clicked)="onSummaryRecord()"
        >
        </zn-button>
        } @case (headerMode.Edit) {
        @if(canEdit()) {
          <zn-button
          [label]="localizationResource.LanguageService + '::Save' | abpLocalization"
          type="primary"
          size="normal"
          (clicked)="onSaveRecord()"
        >
        </zn-button>
        }
        <zn-button
          type="secondary"
          size="normal"
          iconRight="bi bi-x-lg"
          (clicked)="onCancelRecord()"
        >
        </zn-button>
        } @case (headerMode.Duplication) {
        @if(canEdit()) {
          <zn-button
          [label]="localizationResource.LanguageService + '::Save' | abpLocalization"
          type="primary"
          size="normal"
          (clicked)="onSaveRecord()"
        >
        </zn-button>
        }
        <zn-button
          type="secondary"
          size="normal"
          iconRight="bi bi-x-lg"
          (clicked)="onCancelRecord()"
        >
        </zn-button>
        } @default {} }
      </div>
      @if (actions()) {
        <div class="zn-header-col">
          <zn-other-actions [selectedRecords]="selectedRecords()" [actionsOverTable]="actions()?.overTable ?? []"
            [actionsMultipleRecord]="actions()?.multipleRecord ?? []"
            [actionsSingleRecord]="actions()?.singleRecord ?? []"></zn-other-actions>
        </div>
      }
    </div>
  }
</div>
